// extracted by mini-css-extract-plugin
module.exports = {"detail":"DentalContent_detail__3ZuH8","return-form-check-on-next":"DentalContent_return-form-check-on-next__AdWfe","gRecaptchaa":"DentalContent_gRecaptchaa__bQ9kB"};